import React, {useEffect, useState} from 'react';
import { Outlet } from 'react-router-dom'
import RtibbleNavSidBar from './RtibbleNavSidBar';
import RtibbleData from '../../data/RtibbleData.js';
import {useNavigate, useLocation} from 'react-router-dom'
import imgtibble from './tibble_graphics/logo_R_tibble.png'; 
import {Adsggplot} from '../../Ads'


export default function RtibbleIndexLayout() {
    const navigate = useNavigate()
    const location = useLocation()    
    // const paths = [];
    const paths = RtibbleData.filter(data => data.path !== '').map(data => data.path);

    const [currentPage, setCurrentPage] = useState(0)
    
    useEffect(()=> {
        const path = location.pathname
        const parts = path.split('/')
        const currentRoute = parts[parts.length -1]
        const currentRouteIndex = paths.findIndex((element)=> element == currentRoute)
        setCurrentPage(currentRouteIndex)
    }, [location.pathname])
    


    const nextPage = ()=> {
        if(currentPage < paths.length - 1){
            const nextRoute = paths[currentPage +1]
            setCurrentPage(currentPage + 1)
            navigate(nextRoute)
           
        }

    }  
    const prevPage = ()=> {
        if (currentPage>0){
            const previousRoute = paths[currentPage - 1]
            setCurrentPage(currentPage - 1)
            navigate(previousRoute)
        }

    }


    return (
        <div className='main'>
            <div className="row">
        
                <div className="col-md-2 col-sm-12" style={{padding:0}}>
                    <RtibbleNavSidBar currentPage={currentPage}/>
                </div>              

                <div className="col-md-10 col-sm-12" >
                    <div className="row">
                        <div className='col-md-9 p-r-md-60'>
                            {/* <div className='ads-top'>
                                Save this space for Ads                          
                            </div> */}
                            <div className="main-container w-xl-85 mg-t-50">
                                <div className='flexSpaceBetweenCenter'>
                                    <div className="small-logo"><img className="logo-diff img-fluid cover-img" src={imgtibble} /></div>
                                    <div className='flexSpaceBetween'>             
                                        <div className='letter-space-min p-t-5 p-b-5 mg-r-50 center-text'>
                                            <a id="prevPage" onClick={()=>prevPage()}  className='button'>&lt; Previous</a>
                                        </div>
                                        <div className='letter-space-min p-t-5 p-b-5 center-text'>
                                            <a id="nextPage" onClick={()=>nextPage()} className='button'>Next &gt;</a>
                                        </div>
                                    </div>
                                </div>
                                <Outlet />
                            </div>
                            <div className='ads-mid'>
                                {/* Save this space for Ads */}
            
                            </div>
                            <div class="main-container flexSpaceBetween w-xl-85">
                                <div className='letter-space-min p-t-5 p-b-5 center-text'>
                                    <a id="prevPage" onClick={()=>prevPage()}  className='button'>&lt; Previous</a>
                                </div>
                                <div className='letter-space-min p-t-5 p-b-5 center-text'>
                                    <a id="nextPage" onClick={()=>nextPage()} className='button'>Next &gt;</a>
                                </div>
                                
                            </div>
                        </div>
                        
                        <div className='col-md-2 mg-t-150'>

                            {/* This is Ads */}
                        </div>


                    </div>
                    
                </div>
                <div className="col-md-1 col-sm-12">
                    <Adsggplot /> 
                </div>
                

            </div>

        </div>
    )
}